import { computed, ComputedRef } from 'vue';

import authorization from '@rygen/rygen-ui/authorization';
import { CapacityProviderType } from '@rygen/rygen-ui/model';

interface UseCorsairPermissionsResponse {
  hasManageCarriersPermission: ComputedRef<boolean>;
  hasManageBrokersPermission: ComputedRef<boolean>;
  shouldDisableTenderEmail: (carrierType?: CapacityProviderType) => boolean;
}

export const useCorsairPermissions = (): UseCorsairPermissionsResponse => {
  const hasManageCarriersPermission = computed(() =>
    authorization.hasAuthority('client', 'manageCarriers'),
  );

  const hasManageBrokersPermission = computed(() =>
    authorization.hasAuthority('client', 'manageBrokers'),
  );

  const shouldDisableTenderEmail = (
    carrierType?: CapacityProviderType | undefined,
  ) => {
    if (carrierType === CapacityProviderType.CARRIER) {
      return !hasManageCarriersPermission.value;
    } else if (carrierType === CapacityProviderType.BROKER) {
      return !hasManageBrokersPermission.value;
    } else {
      return true;
    }
  };

  return {
    hasManageCarriersPermission,
    hasManageBrokersPermission,
    shouldDisableTenderEmail,
  };
};
